import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import router from '@/_router';
import { RawLocation } from 'vue-router';
import { navigateEditSessionTarget, NavigationRegistration, NavigationResult } from '@/_router/editSessionNavigation';
import { buildStorymapCardRoute } from '../../utils/publishedStorymapRoutes';

const store = useStorymapStore();
const { registerMiddleware, registerReducer } = store;
const completions = new WeakMap<OpenCardDetails, Promise<NavigationResult>>();

export class OpenCardDetails extends Action<StorymapState> {
    public static ACTION_TYPE = 'OpenCardDetails';
    /** Local observation; Flux dispatch still reports middleware admission separately. */
    public get _completion(): Promise<NavigationResult> { return completions.get(this) ?? Promise.resolve({ type: 'unchanged' }); }

    public constructor(
        public cardId: string,
        public options: { callbackAfterClose?: () => void; navigation?: NavigationRegistration; destination?: RawLocation } = {
            callbackAfterClose: () => {
                /* */
            },
        }
    ) {
        super(OpenCardDetails.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: OpenCardDetails): Promise<boolean> => {
    const callback = action.options.callbackAfterClose;
    const ownerId = state.id;
    const ownerSlug = state.slug;
    const destination = action.options.destination ?? buildStorymapCardRoute(state.slug, action.cardId, {
        isPublishedRecipient: state.isPublishedRecipient,
        accessKind: state.publishedAccessKind,
        accessKey: state.publishedAccessKey,
    });
    completions.set(action, navigateEditSessionTarget(router, destination, action.options.navigation).then(result => {
        if (result.type === 'completed' && store.state === state && state.id === ownerId && state.slug === ownerSlug && router.currentRoute === result.route) {
            state.cardDetailsDialogState.callbackAfterClose = callback;
        }
        return result;
    }));
    return true;
};

//@ts-ignore
registerMiddleware(OpenCardDetails.ACTION_TYPE, middleware);

// Keep the existing Flux dispatch boolean; navigation is observed through _completion.
registerReducer(OpenCardDetails.ACTION_TYPE, () => undefined);
